module.exports = __webpack_public_path__ + "static/media/energy-smart-leave.a30d48dd.svg";